module.exports = __webpack_public_path__ + "img/logo.78cc5e62.png";